module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/law.svg?04660a3b";